/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetReportDefinitionByIdQueryResponse, AuditReportsGetReportDefinitionByIdPathParams, AuditReportsGetReportDefinitionById401, AuditReportsGetReportDefinitionById403, AuditReportsGetReportDefinitionById404 } from "../models/AuditReportsGetReportDefinitionById";

export function getAuditReportsGetReportDefinitionByIdUrl(id: AuditReportsGetReportDefinitionByIdPathParams["id"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/report-definitions/by-id/${id}` as const }
  return res
}

/**
 * @description Retrieves a specific report definition by its unique identifier
 * @summary Get report definition by ID
 * {@link /audit-reports/v1/report-definitions/by-id/:id}
 */
export async function auditReportsGetReportDefinitionById(id: AuditReportsGetReportDefinitionByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetReportDefinitionByIdQueryResponse, ResponseErrorConfig<AuditReportsGetReportDefinitionById401 | AuditReportsGetReportDefinitionById403 | AuditReportsGetReportDefinitionById404>, unknown>({ method : "GET", url : getAuditReportsGetReportDefinitionByIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}